import {Component, inject, OnInit} from '@angular/core';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { CommonModule } from '@angular/common';
import { AlertStatusService } from "../../services/alert-status/alert-status.service";
import { NzNotificationModule, NzNotificationService } from 'ng-zorro-antd/notification';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import {take, takeUntil} from "rxjs";

@Component({
  selector: 'alert-status',
  standalone: true,
  imports: [NzInputModule, NzFormModule, FormsModule, NzButtonModule, NzIconModule, NzRadioModule, CommonModule, NzNotificationModule, NzSpinModule],
  templateUrl: './alert-status.component.html',
  styleUrl: './alert-status.component.scss'
})
export class AlertStatusComponent  implements OnInit{
  alertStatusService = inject(AlertStatusService);
  notification = inject(NzNotificationService)
  alert = {
    message: '',
    color: '#dddee1'
  };
  loading = false;

  colors: string[] = [
    '#dddee1',
    '#adcbfb',
    '#bde97c',
    '#fbd779',
    '#ffb8b2',
    '#e3bdfa'
  ];

  ngOnInit(): void {
    this.getAlertStatus();
  }

  save(): void {
    this.saveAlertStatus();
  }

  deleteAlertStatus() {
    this.loading = true;
    this.alertStatusService.deleteAlertStatus().subscribe({
      next: () => {
        this.alert = {
          message: '',
          color: '#dddee1'
        }
        this.loading = false;
        this.notification.success('Success',  'The alert has been successfully removed.')
      },
      error: err => {
        this.loading = false;
        this.notification.error('Error', err.mesage);
      }
    })
  }

  saveAlertStatus() {
    this.loading = true;
    this.alertStatusService.setAlertStatus(this.alert).subscribe({
      next: res => {
        this.loading = false;
        this.notification.success('Success', 'The alert was saved successfully')
      },
      error: err => {
        this.loading = false;
        this.notification.error('Error', err.mesage);
      }
    })
  }

  getAlertStatus(){
    this.loading = true;
    this.alertStatusService.getAlertStatus().subscribe({
      next: res => {
        if(res){
          this.alert = res;
        }
        this.loading = false;
      },
      error: err => {
        this.loading = false;
        if(err.status !== 404){
          this.notification.error('Error', err.mesage);
        }
      }
    })
  }
}
